// src/lib/patientLinks.ts
// One-time patient link system � tokens stored in Firestore, consumed on first open.

import { db } from './firebase';
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';

const COLLECTION = 'patientLinks';
const EXPIRY_HOURS = 48;

function generateToken(): string {
  const array = new Uint8Array(18);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

export async function createPatientLink(calcId: string): Promise<string> {
  const token = generateToken();
  const expiresAt = new Date();
  expiresAt.setHours(expiresAt.getHours() + EXPIRY_HOURS);

  await setDoc(doc(db, COLLECTION, token), {
    calcId,
    used: false,
    createdAt: serverTimestamp(),
    expiresAt: expiresAt.toISOString(),
  });

  return `https://iq-doctor-2cba8.web.app/#patient-link=${token}`;
}

export async function consumePatientLink(
  token: string
): Promise<{ calcId: string } | null> {
  try {
    const ref = doc(db, COLLECTION, token);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data();
    if (data.used === true) return null;
    if (data.expiresAt && new Date() > new Date(data.expiresAt)) return null;
    await updateDoc(ref, { used: true });
    return { calcId: data.calcId };
  } catch {
    return null;
  }
}
